<template>
  <div class="search-overlay-content px-3">
    <div class="upper-controls shadow py-3 mx-n3">
      <form v-on:submit.prevent="search" v-on:keydown.enter.prevent="search" class="px-3 d-flex align-items-center w-100 flex-grow-1">
        <div :title="t.modal_close" class="text-white align-self-center" v-on:click="close" role="button">
            <i class="fas fa-times fa-2x"></i>
        </div>
        <div class="input-group ml-3 w-100">
          <input class="form-control d-none d-md-block form-control-lg border-0" type="search" v-model="searchField" placeholder="Search millions of photos" name="search" style="border-radius: 10px 0px 0px 10px;">
          <input class="form-control d-block d-md-none border-0" type="search" v-model="searchField" placeholder="Search millions of photos" name="search" style="border-radius: 10px 0px 0px 10px;">
            <div class="input-group-append">
              <button type="submit" class="btn bg-primary text-white border-bottom-0"  style="border-radius: 0px 10px 10px 0px;">
                <i class="fa fa-2x fa-search d-none d-md-block"></i>
                <i class="fa fa-search d-block d-md-none" style="font-size: 1.5rem;"></i>
              </button>
            </div>
        </div>
      </form>
    </div>
    <div class="scroll-container" v-on:scroll.passive="scrollHandler">
      <div v-if="noImagesFound" class="error my-3 p-3">
        <strong><span class="mr-1">😐</span> Sorry, nothing found for "{{searchField}}"</strong><br/>
        Please try again or use the suggestions below.
      </div>
      <div class="suggestion-pills my-3">
        <span style="color: #CCCCCC;">Try:</span>
        <button class="btn btn-default" v-bind:key="index"
          v-for="(suggestion, index) in suggestions" @click="search(suggestion)"
          :disabled="!pixabayImages || !pixabayImages.suggestions"
          v-html="suggestion"
        >
        </button>
      </div>
      <div class="d-lg-none mobile-suggestion-text mb-1"><a href="https://pixabay.com" target="_blank" class="mobile-suggestion-link">Images are from Pixabay, and free to use</a></div>

      <div class="image-list row row-cols-2 row-cols-md-4 mx-n2">
        <div class="col mb-3 px-2"
            v-bind:key="image.image_url"
            v-for="image in images">
          <div
            class="item position-relative"
            role="button"
            v-bind:style="image.thumbnail_url ? {'background-image': `url('${image.thumbnail_url}')`} : {}"
            @mouseover="hover=image.image_url"
            @mouseleave="hover=null; attribution=null;"
            @click="select(image)"
          >
            <div style="position: absolute; z-index: -1; top: 0; left: 0; right: 0; bottom: 0; background-color: gray;"></div>
            <img :src="foregroundUrl" style="max-width: 100%;"/>
            <div v-if="attribution && attribution!=image.image_url" style="position: absolute; z-index: 1; top: 0; left: 0; right: 0; bottom: 0; background-color: rgb(0,0,0,0.5);"></div>
            <span class="d-none d-lg-block" v-if="image.attribution">
              <div class="info-hover text-center"
                v-show="hover==image.image_url || attribution==image.image_url"
                @click.stop="attribution=image.image_url"
                @mouseover="hover_info=image.image_url"
                @mouseleave="hover_info=null;"
                :style="(hover_info==image.image_url || attribution==image.image_url) ? {'opacity': 1} : {'opacity': 0.5}"
              >
                <i class="fas fa-info text-white">
                </i>
                <div v-if="attribution==image.image_url" class="attribution-hover mt-1">
                  <a class="attribution-link" target="_blank" :href='image.attribution.user_url'>By {{image.attribution.user}}</a>
                  <a class="attribution-link" target="_blank" :href='image.attribution.url'>on {{image.attribution.source}}</a>
                  <br/>
                  <a class="attribution-link" target="_blank" href='https://pixabay.com/service/license/'>{{image.attribution.usage}}</a>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchImages from '../src/image_search';
import I18n from '../src/editor/i18n';

export default {
  props: {
    pixabayImages: Object,
    locale: String,
    foregroundUrl: String
  },
  data() {
    return {
      hover: null,
      hover_info: null,
      attribution: null,
      noImagesFound: false,
      images: null,
      suggestions: null,
      searchField: null,
      t: I18n(this.locale),
      currentPage: null,
    };
  },
  created: function () {
    if (!this.pixabayImages) {
      this.createPlaceholderList();
      this.suggestions =  Array(15).fill("&nbsp;")
    } else {
      this.images = JSON.parse(JSON.stringify(this.pixabayImages.images));
      this.suggestions = this.pixabayImages.suggestions;
    }

  },
  watch: {
    pixabayImages: function(val) {
      this.images = JSON.parse(JSON.stringify(val.images));
      this.suggestions = JSON.parse(JSON.stringify(val.suggestions));
    }
  },
  methods: {
    createPlaceholderList() {
      this.images = new Array(20);
      for (var i=0; i<this.images.length; ++i) {
        this.images[i]={
          image_url:i
        };
      }
    },
    scrollHandler(event) {
      if(event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight){
        this.loadMoreResults();
      }
    },
    loadMoreResults() {
      this.search(this.searchField, true, this.currentPage+1);
    },
    close() {
      this.$emit("close");
    },
    search: function(search_term, append = false, page = 1, per_page = 20) {
      window.track("Editor", "search_pixabay_image", search_term);
      if(window.hj) window.hj('trigger', 'pixabay_select', search_term);

      if (!append) {
        this.createPlaceholderList();
      }

      let that = this;
      if (typeof search_term!="string") {
        search_term = this.searchField;
      } else {
        this.searchField = search_term;
      }
      this.currentPage = page;

      searchImages(search_term, page, per_page).then((images) => {
        if (images.length==0) {
          this.images = JSON.parse(JSON.stringify(this.pixabayImages.images)); // load initial suggestion result when no result found
          that.noImagesFound = true;
        } else {
          if (append) {
            that.images = that.images.concat(images);
          } else {
            that.images = images;
          }

          that.noImagesFound = false;
        }
      })
    },
    select: function(image) {
      window.track("Editor", "select_pixabay_image", image.image_url);
      if(window.hj) window.hj('trigger', 'pixabay_select', image.image_url);

      this.$emit("change", {newValue: image.image_url});
      this.close();
    }
  }
}
</script>
<style scoped>
  .error {
    width: 100%;
    color: #454545;
    background: #FEECCB;
    border-radius: 6px;

  }
  .search-overlay-content {
    background: #272727;
    position: relative;
    z-index: 19050;
    height: 100%;
  }

  input:focus {
    box-shadow: none;
  }

  .btn-default {
    color: #FFF;
    background: #54616C;
    letter-spacing: 1px;
    line-height: 15px;
    border-radius: 40px;
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
  }

  .btn-default:hover {
    background: #687683;
  }

  .bg-blue {
    background: #2699FB;
  }

  .bg-blue:hover {
    background: #2287E0;
  }

  .search-button {
    border-radius: 0 10px 10px 0 !important;
    font-size: 20px;
    color: white;
  }

  .close-button {
    cursor: pointer;
    z-index: 18000;
    background:transparent;
    padding: 0px;
    margin-right: 5px;
    border: none;
  }

  div[role="button"] {
    cursor: pointer;
  }

  @media(min-width: 768px) {
    .close-button {
      width: 40px;
      height: 40px;
      font-size: 20px;
    }
  }

  .upper-controls {
    position: relative;
    z-index: 1000;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);

    display:-webkit-flex;
    display: flex;
    justify-content: space-between;

  }

  .scroll-container {
    overflow-x: hidden;
    overflow-y: auto;
    height: calc(100% - 80px);

  }

  .image-list .item {
    border: 1px solid #454545;
    outline: none;
    background-position: center;
    background-size: cover;
    background-color: transparent;
  }

  .image-list .item.active {
    border-color: #fff;
  }

  .image-list .item:hover {
    border: 1px solid #EDEFF0;
  }


  .picker {
    background: #6f6f70;
    color: #fff;
    line-height: 1;
    font-weight: 400;
  }
  .image-list .item .foreground-thumbnail {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }

  .suggestion-pills {
    padding-top: 5px;
    margin-top: 13px;
    padding-bottom: 5px;
    margin-bottom: 11px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .suggestion-pills.btn:hover {
    background-color: #687683;
  }
  .suggestion-pills.btn {
    display: inline-block;
  }

  .info-hover {
    width: 24px;
    height: 24px;
    background-color: black;

    position: absolute;
    top: 8px;
    right: 8px;
    border-radius: 5px;
  }

  .mobile-suggestion-link {
    text-decoration: none;
    color: #999999;
    font-size: 12px;
  }

  .attribution-hover {
    background-color: white;
    border-radius: 5px;
    position: relative;
    top: 0px;
    left: -156px;
    opacity: 1;
    width: 180px;
    /* height: 80px; */
    padding: 12px;
    font-size: 12px;
    font-weight: 400;
    z-index: 100;
    text-align: left;
  }

  .attribution-link {
    text-decoration: none;
    color: #54616C;
  }

  .attribution-link:hover {
    text-decoration: underline;
  }
</style>
